import type { AgentComponent } from '@reach/shared-types/agent-components';
import { Link } from 'react-router-dom';
import { EditIconLink } from '../../../components/ui/EditIconLink';
import { TrashIconButton } from '../../../components/ui/TrashIconButton';
import { componentPath } from '../agent-component-paths';
import { ModeBadge } from '../ModeBadge';
import styles from './TemplateComponentItem.module.css';

interface TemplateComponentItemProps {
  component: AgentComponent;
  isRemoving: boolean;
  onRemove: () => void;
}

export const TemplateComponentItem = ({
  component,
  isRemoving,
  onRemove,
}: TemplateComponentItemProps) => {
  const { id, type, name, description, mode } = component;
  const path = componentPath(type, id);
  const editLabel = `Edit ${name}`;
  const removeLabel = `Remove ${name} from the template`;

  return (
    <li className={styles.templateComponentItem}>
      <div>
        <Link to={path}>{name}</Link>
        {description && <p>{description}</p>}
      </div>
      <ModeBadge mode={mode} />
      <EditIconLink to={path} label={editLabel} />
      <TrashIconButton
        tooltip="Remove from template"
        label={removeLabel}
        disabled={isRemoving}
        onClick={onRemove}
      />
    </li>
  );
};
